import React from "react";

function PlaymakerItem({ playmaker }) {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h4 className="font-medium text-md">{`${playmaker.name} ${playmaker.lastName}`}</h4>
        {playmaker.phone && (
          <div className="text-sm text-gray-500">Tel: {playmaker.phone}</div>
        )}
      </div>
    </div>
  );
}

export default PlaymakerItem;
